import { keyframes } from "@emotion/react";

import { toRem, toRems } from "../../../../helpers/theme";
import { normalizeDimension } from "../../../../helpers/utils";

const animAutoFill = keyframes({ from: {} });
const animAutoFillCancel = keyframes({ from: {} });

const config = {
    fontSize: 16,
    borderRadius: 8,
    normal: {
        padding: [12, 22],
        height: 48,
    },
};

const style = ({
    theme,
    labelAlignLeft,
    size,
    variant,
    fieldWidth,
    inputWidth,
    disabled,
    focused,
    error,
    noResize,
    hasActionComponent,
    isActionComponentTitle,
}) => ({
    position: "relative",
    margin: 0,
    padding: 0,
    display: "flex",
    flexDirection: "column",
    verticalAlign: "top",
    width: "100%",
    ...(fieldWidth && {
        maxWidth: normalizeDimension(fieldWidth, true),
    }),
    [theme.breakpoints.up("md")]: {
        ...(labelAlignLeft && {
            flexDirection: "row",
            alignItems: "flex-start",
        }),
    },
    "& .inputContainer": {
        display: "flex",
        flexDirection: "column",
        flex: 1,
        alignItems: "flex-start",
        width: "100%",
        "&_inner": {
            display: "flex",
            flexDirection: "row",
            flex: 1,
            width: "100%",
        },
    },
    "& .inputWrap": {
        position: "relative",
        cursor: "text",
        boxSizing: "border-box",
        alignItems: "center",
        width: "100%",
        background: error
            ? theme.colors.form.error.background
            : theme.colors.form.input[variant]?.background?.default,
        border: "1px solid",
        borderColor: error
            ? theme.colors.form.error.border
            : theme.colors.form.input[variant]?.border?.default,
        borderRadius: toRem(config.borderRadius),
        boxShadow: "none",
        transitionDuration: theme.transitions.input.text.default.duration,
        transitionTimingFunction: theme.transitions.input.text.default.timingFunction,
        transitionDelay: theme.transitions.input.text.default.delay,
        transitionProperty: "color, background, border-color, box-shadow",
        ...(inputWidth && {
            maxWidth: normalizeDimension(inputWidth, true),
        }),
        ...(focused && {
            outline: 0,
            background: error
                ? theme.colors.form.error.background
                : theme.colors.form.input[variant]?.background?.focus,
            borderColor: error
                ? theme.colors.form.error.border
                : theme.colors.form.input[variant]?.border?.focus,
            boxShadow: error ? "none" : theme.shadows.input.focus,
        }),
        ...(disabled && {
            cursor: "not-allowed",
        }),
        [theme.breakpoints.up("md")]: {
            ...(labelAlignLeft && {
                flex: 1,
            }),
        },
        "&:hover": {
            ...(!disabled && {
                borderColor: error
                    ? theme.colors.form.error.border
                    : theme.colors.form.input[variant]?.border?.hover,
            }),
        },
        textarea: {
            font: "inherit",
            color: error
                ? theme.colors.form.error.text
                : theme.colors.form.input[variant]?.text?.default,
            padding: toRems(config[size]?.padding),
            border: 0,
            borderRadius: toRem(config.borderRadius),
            boxSizing: "border-box",
            background: "none",
            margin: 0,
            WebkitTapHighlightColor: "transparent",
            display: "block",
            minWidth: 0,
            width: "100%",
            minHeight: toRem(140),
            fontSize: toRem(config.fontSize),
            resize: "vertical",
            animationDuration: "10ms",
            animationName: animAutoFillCancel,
            ...(noResize && {
                resize: "none",
            }),
            ...(hasActionComponent && {
                paddingBottom: toRem(52), // for small button variant
            }),
            "&::placeholder": {
                color: error
                    ? theme.colors.form.error.text
                    : theme.colors.form.input[variant]?.text?.placeholder,
                opacity: 1,
            },
            "&:focus": {
                outline: 0,
            },
            "&:disabled": {
                cursor: "not-allowed",
                color: theme.colors.form.input[variant]?.text?.disabled,
            },
            "&:invalid": {
                boxShadow: "none",
            },
            "&:-webkit-autofill": {
                animationDuration: "5000s",
                animationName: animAutoFill,
            },
        },
    },
    "& .inputAction": {
        display: "flex",
        position: "absolute",
        zIndex: theme.zIndex.over,
        right: toRem(10),
        bottom: isActionComponentTitle ? toRem(20) : toRem(10),
    },
});

export default style;
